<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [style]="{ width: '320px' }"
  (onHide)="onHide()"
>
  <div class="session-timeout-dialog">
    <div class="session-timeout-dialog__icon">
      <i class="pi pi-question-circle"></i>
    </div>
    <h3 class="session-timeout-dialog__title">Are you still scanning?</h3>
    <div class="session-timeout-dialog__actions">
      <button
        pButton
        type="button"
        label="NO"
        class="p-button-text session-timeout-dialog__btn session-timeout-dialog__btn--no font-bold"
        (click)="onEnd()"
      ></button>
      <button
        pButton
        type="button"
        label="YES"
        class="p-button-text session-timeout-dialog__btn session-timeout-dialog__btn--yes font-bold"
        (click)="onContinue()"
      ></button>
    </div>
  </div>
</p-dialog>
